class DraftDeleteModal {
  constructor(delele_project_id, localKey) {
    this.localKey = localKey;
    this.openDraftModal = this.openDraftModal.bind(this);
    this.closeDraftModal = this.closeDraftModal.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.delele_project_id = delele_project_id;
    this.findModal = undefined;
    this.openDraftModal();
  }

  openDraftModal() {
    this.findModal = document.getElementById("confirmationModal");

    if (!this.findModal) {
      this.findModal = `<div id="confirmationModal" class="draft-modal">
                            <div class="draft-modal-content">
                                <h3>Would you like to delete this project?</h3>
                                <p>If you delete it permanently, it won’t be accessible anymore.</p>
                                <div class="draft-modal-buttons">
                                <button class="draft-btn draft-btn-cancel">Cancel</button>
                                <button class="draft-btn draft-btn-delete" data-delele-id=${this.delele_project_id}>Delete permanently</button>
                                </div>
                            </div>
                            </div>`;

      this.findModal = new DOMParser().parseFromString(
        this.findModal,
        "text/html"
      ).body.firstElementChild;
    } else {
      this.findModal
        .querySelector(".draft-btn-delete")
        .setAttribute("data-delele-id", this.delele_project_id);
    }
    const cancelButton = this.findModal.querySelector(".draft-btn-cancel");
    const deleteButton = this.findModal.querySelector(".draft-btn-delete");
    cancelButton.addEventListener("click", () => {
      this.closeDraftModal();
    });
    deleteButton.addEventListener("click", () => {
      this.deleteItem();
    });
    document.body.appendChild(this.findModal);
  }

  closeDraftModal() {
    this.findModal.remove();
  }

  deleteItem() {
    const findData = JSON.parse(localStorage.getItem(this.localKey)) || [];
    const remove_project = [...findData].filter(
      (item) => item.project_id !== Number(this.delele_project_id)
    );
    localStorage.setItem(this.localKey, JSON.stringify(remove_project));
    const cardToRemove = document
      .querySelector(`[data-project_id="${this.delele_project_id}"]`)
      ?.closest(".draft-card");

    if (cardToRemove) {
      cardToRemove.remove();
    }
    this.closeDraftModal();
  }
}

class ProductPersonalize extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("#open-editor");
    const draftButton = this.querySelector("#show-draft-project");
    this.from = this.getAttribute("from");
    this.loadType = "product";
    this.data = {};
    this.handleClose = this.handleClose.bind(this);
    this.onLoadTool = this.onLoadTool.bind(this);
    this.onHistoryChange = this.onHistoryChange.bind(this);
    this.handleMessageEvent = this.handleMessageEvent.bind(this);
    this.handleEditDraft = this.handleEditDraft.bind(this);
    this.handleStoreLocalStorageData =
      this.handleStoreLocalStorageData.bind(this);
    this.handleUpdateDraftDataAgainstCustomer =
      this.handleUpdateDraftDataAgainstCustomer.bind(this);
    this.iframe = null;
    this.url = "https://designer.thetravellermaps.com/frontend";  
    this.body = document.getElementsByTagName("body")[0];
    this.localKey = "draft-project";

    if (this.from === "product" && button) {
      this.extraPageprice = this.getAttribute("extra-page-price");
      this.currencySymbol = this.getAttribute("data-currancy-symbol");
      this.extraPageVariantId = this.getAttribute("extra-page-variantId");
      this.lang = this.getAttribute("data-store-isocode");
    } else if (this.from === "account") {
      let customerEmail = this.getAttribute("data-customer");
      let draftProject = JSON.parse(localStorage.getItem(this.localKey));
      if (Array.isArray(draftProject) && draftProject.length && customerEmail) {
        this.handleUpdateDraftDataAgainstCustomer(draftProject, customerEmail);
      }
    }

    if (draftButton) {
      const drafDrawer = `<div class="draft-drawer" id="draft-drawer">

              <div class="draft-drawer-header">
                <p>My drafts</p>
                <button
                  style="position: absolute;top: 20px;right: 20px;cursor: pointer;font-size: 30px;font-weight: bold;background: none;color: black;border:none"
                  id="draft-closeBtn">
                  &times;
                </button>
              </div>
              <div class="draft-drawer-content" id="drawer-content-data">
              </div>
            </div>`;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = drafDrawer;
      this.body.appendChild(tempDiv.firstElementChild);

      draftButton.addEventListener("click", () => {
        this.handleEditDraft();
      });
    }

    if (this.from === "product" && this.loadType === "product" && button) {
      window.addEventListener("popstate", this.onHistoryChange);
      this.defineUi();

      button.addEventListener("click", () => {
        // 🔑 Rebuild this.data fresh from current button attributes
        this.data = {
          productId: button.getAttribute("data-product-id"),
          sku: button.getAttribute("data-product-sku"),
          email: button.getAttribute("data-customer-email"),
          title: button.getAttribute("data-product-title"),
          varientId: button.getAttribute("data-product-varientId"),
          extraPageprice: this.extraPageprice,
          extraPageVariantId: this.extraPageVariantId,
          productPrice: button.getAttribute("data-product-price"),
          lang: this.lang,
          compareAtprice: button.getAttribute("data-product-compare-at-price"),
          currencySymbol: this.currencySymbol,
        };

        console.log(this.data, 'data'); // ✅ now reflects the selected variant

        window.removeEventListener("message", this.handleMessageEvent);
        window.addEventListener("message", this.handleMessageEvent);
        this.onLoadTool();
        this.addQueryParam("sku", this.utf8ToBase64());
      });
    }
  }

  defineUi() {
    const url = new URL(window.location);
    let serachParams = url.searchParams.get("sku");
    if (serachParams) {
      this.onLoadTool();
      window.removeEventListener("message", this.handleMessageEvent);
      window.addEventListener("message", this.handleMessageEvent);
    }
  }

  onHistoryChange(event) {
    event.preventDefault();
    const url = new URL(window.location);
    let serachParams = url.searchParams.get("sku");
    if (!serachParams) {
      this.handleClose();
    } else {
      this.onLoadTool();
    }
  }

  onLoadTool() {
    const creatdiv = document.createElement("div");
    creatdiv.classList.add("modal");
    creatdiv.setAttribute("id", "px-modal-12");

    const creatModaldiv = document.createElement("div");
    creatModaldiv.classList.add("modal-content");

    // Loader
    const loader = document.createElement("div");
    loader.classList.add("editor-loader");

    loader.innerHTML = `
    <div class="loader-bars">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p>Loading editor...</p>`;

    const creatIframe = document.createElement("iframe");
    creatIframe.src = `${this.url}?sku=${this.utf8ToBase64()}`;
    creatIframe.width = "100%";
    creatIframe.height = "100%";

    // Hide iframe initially
    creatIframe.style.display = "none";

    // When iframe loads
    creatIframe.onload = () => {
      loader.style.display = "none";
      creatIframe.style.display = "block";
    };

    creatModaldiv.appendChild(loader);
    creatModaldiv.appendChild(creatIframe);
    creatdiv.appendChild(creatModaldiv);

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    document.body.appendChild(creatdiv);
  }

  utf8ToBase64() {
    const url = new URL(window.location);
    let serachParams = url.searchParams.get("sku");
    if (!serachParams) {
      const str = JSON.stringify({ skuData: { ...this.data } });
      const bytes = new TextEncoder().encode(str);
      return btoa(String.fromCharCode(...bytes));
    }
    return serachParams;
  }

  base64ToUtf8(base64str) {
    const base64 = decodeURIComponent(base64str);
    const binaryStr = atob(base64);
    const bytes = Uint8Array.from(binaryStr, (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  addQueryParam(param, value) {
    const url = new URL(window.location);
    url.searchParams.set(param, value);
    window.history.pushState({ modal: "open" }, "", url);
  }

 handleClose() {
    console.log("close button clicked !");
    window.removeEventListener("message", this.handleMessageEvent);
    document.querySelector("#px-modal-12")?.remove();
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  async handleMessageEvent(event) {
    const { type, payload } = event.data;
    
    // console.log('this is the payload', payload);

    if (type === "ADD_TO_CART") {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }).then((response) => response.ok && window.location.replace("/cart"));
    } else if (type === "SAVE_PROJECT") {
      if (!this.data.email) {
        localStorage.setItem("project_id", JSON.stringify(payload.project_id));
      }
      window.location.href = "/account?project_id=" + payload.project_id;
    } else if (type === "CLOSE_PROJECT") {
      const url = new URL(window.location);
      url.searchParams.delete("sku");
      window.location = url.toString();
    } else if (type === "DRAFT_PROJECT") {
      const url = location.origin + location.pathname;
      const storeData = {
        productUrl: url.toString(),
        project_id: payload.project_id,
        productId: payload.productId,
        varientId: payload.varientId,
        title: payload.title,
        sku: payload.sku,
        product_image: payload.product_image,
        extraPageVariantId: payload.extraPageVariantId,
        extraPageprice: payload.extraPageprice,
        productPrice: payload.productPrice,
        currencySymbol: payload.currencySymbol,
      };
      this.handleStoreLocalStorageData(storeData);
    }
  }

  handleEditDraft() {
    const drawer = document.getElementById("draft-drawer");
    const closeBtn = drawer.querySelector("#draft-closeBtn");
    const contentWrapper = drawer.querySelector("#drawer-content-data");

    const toggleDrawer = () => {
      const isOpen = drawer.classList.contains("open");
      drawer.classList.add("open");
      // document.body.style.overflowY = isOpen ? "auto" : "hidden";
    };

    const removeDrawer = () => {
      drawer.classList.remove("open");
      contentWrapper.replaceChildren();
    };

    const arrayData = JSON.parse(localStorage.getItem(this.localKey)) || [];

    closeBtn.addEventListener("click", (e) => {
      removeDrawer();
    });

    if (arrayData.length) {
      // console.log(arrayData, "this.localData")
      arrayData.forEach((item) => {
        let update = `<div  class="draft-card">
                    <object
                      data="${item.product_image}"
                      type="image/svg+xml"
                      style="width: 100%; max-width: 50%; height: auto;"
                    ></object>

                    <div class="draft-content">
                        <p class="draft-title">${item.title}</p>
                        <div class="buttons">
                            <button 
                            data-productId=${item.productId}
                            data-varientId=${item.varientId}
                            data-sku=${item.sku}
                            data-project_id=${item.project_id}
                            data-productUrl=${item.productUrl} 
                            data-product_price=${item.productPrice}
                            data-currency_symbol=${item.currencySymbol}
                            data-extrapage_id=${item.extraPageVariantId}
                            data-extra_price=${item.extraPageprice}
                            style="padding: 8px 16px; border: 1px solid black; color:black; border-radius: 20px; background: white; cursor: pointer; margin-right: 10px;">Edit</button>
                            <button
                            data-project_id=${item.project_id}
                            style="padding: 8px 16px; border: 1px solid black; border-radius: 20px; background: white; cursor: pointer; color:black" >Delete</button>
                        </div>
                    </div>
                </div>`;
        contentWrapper.innerHTML += update;
      });
      contentWrapper.addEventListener("click", (event) => {
        if (event.target.innerHTML === "Edit") {
          // console.log(event.target.getAttribute("data-productId"), "productId")

          this.data = {
            productId: event.target.getAttribute("data-productId"),
            sku: event.target.getAttribute("data-sku"),
            varientId: event.target.getAttribute("data-varientId"),
            project_id: event.target.getAttribute("data-project_id"),
            title: event.target.getAttribute("data-title"),
            extraPageVariantId: event.target.getAttribute("data-extrapage_id"),
            extraPageprice: event.target.getAttribute("data-extra_price"),
            productPrice: event.target.getAttribute("data-product_price"),
            currencySymbol: event.target.getAttribute("data-currency_symbol"),
          };

          const productUrl = event.target.getAttribute("data-productUrl");
          // console.log(this.data, "productUrl")
          const sku = this.utf8ToBase64();

          window.location.href = productUrl + "?sku=" + sku;
        } else if (event.target.innerHTML === "Delete") {
          // console.log("deleteclicked")
          let project_id = event.target.getAttribute("data-project_id");
          // console.log(event.target.getAttribute("data-project_id"))
          const confirmationModal = new DraftDeleteModal(
            project_id,
            this.localKey
          );
        }
        // console.log(event.target.innerHTML, "target")
      });
    }
    toggleDrawer();
  }

  handleStoreLocalStorageData(storeData) {
    const findData = JSON.parse(localStorage.getItem(this.localKey)) || [];
    if (findData.length) {
      const isExistingProject = findData.filter(
        (item) => item.project_id === storeData.project_id
      );
      if (isExistingProject.length) {
        localStorage.setItem(
          this.localKey,
          JSON.stringify(
            findData.map((item) => {
              if (item.project_id === storeData.project_id) {
                return {
                  ...item,
                  ...storeData,
                };
              }
              return item;
            })
          )
        );
      } else {
        let updatedData = [...findData, storeData];
        localStorage.setItem(this.localKey, JSON.stringify(updatedData));
      }
    } else {
      const createLocalStorage = [storeData];
      localStorage.setItem(this.localKey, JSON.stringify(createLocalStorage));
    }
    // const url = new URL(window.location);
    // url.searchParams.delete("sku");
    // window.location = url.toString();
  }

  async handleUpdateDraftDataAgainstCustomer(draftProject, customerEmail) {
    try {
      const register = await Promise.all(
        draftProject.map(async (project) => {
          let result = await fetch(
            "https://designer.thetravellermaps.com/api/project/update/user",   
            {
              method: "post",
              headers: { "content-type": "application/json" },
              body: JSON.stringify({
                email: customerEmail,
                id: project.project_id,
              }),
            }
          );
          return result.ok;
        })
      );
    } catch (error) {
      console.log("Error in save project");
    }
  }
}
customElements.define("product-personalize", ProductPersonalize);